/* CatSketch room-only guard: keep selected product surfaces from showing flat/zoom where room-only is required. */
(function () {
  var ROOM_ONLY = {};

  function currentProductHandle() {
    var match = (location.pathname || '').match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function installProductRoomOnlyGuard() {
    if (!ROOM_ONLY[currentProductHandle()]) return;

    try {
      var style = document.createElement('style');
      style.id = 'clawdbot-room-only-whitefix';
      style.textContent =
        '.product__media img,.product__media-item img,.product__media-list img{opacity:1!important;visibility:visible!important;}.clawdbot-zoom-overlay,.clawdbot-flat-cycle-overlay{display:none!important;}';
      (document.head || document.documentElement).appendChild(style);
    } catch (error) {}

    function killFns() {
      ['clawdbotGetFlatUrlForSourceUrl', 'clawdbotGetLegacyFlatInfo', 'clawdbotGetLegacyZoom', 'clawdbotGetMetafieldZoom'].forEach(
        function (name) {
          try {
            Object.defineProperty(window, name, {
              configurable: true,
              writable: true,
              value: function () {
                return null;
              },
            });
          } catch (error) {
            try {
              window[name] = function () {
                return null;
              };
            } catch (ignored) {}
          }
        },
      );
    }

    function clearZoomJson() {
      var zoom = document.getElementById('clawdbot-product-zoom');
      if (zoom) zoom.textContent = '{}';
    }

    function stripOverlays(root) {
      (root || document).querySelectorAll('.clawdbot-zoom-overlay,.clawdbot-flat-cycle-overlay').forEach(function (overlay) {
        overlay.remove();
      });
    }

    function restoreBase() {
      document.querySelectorAll('.product__media img,.product__media-item img').forEach(function (image) {
        image.style.setProperty('opacity', '1', 'important');
        image.style.setProperty('visibility', 'visible', 'important');
      });
    }

    function pass() {
      killFns();
      clearZoomJson();
      stripOverlays();
      restoreBase();
    }

    pass();
    document.addEventListener('DOMContentLoaded', pass);

    try {
      new MutationObserver(function (mutations) {
        var touched = false;
        mutations.forEach(function (mutation) {
          if (mutation.addedNodes) {
            for (var index = 0; index < mutation.addedNodes.length; index += 1) {
              var node = mutation.addedNodes[index];
              if (
                node.nodeType === 1 &&
                node.classList &&
                (node.classList.contains('clawdbot-zoom-overlay') || node.classList.contains('clawdbot-flat-cycle-overlay'))
              ) {
                node.remove();
                touched = true;
              }
            }
          }
          if (
            mutation.type === 'attributes' &&
            mutation.target &&
            mutation.target.tagName === 'IMG' &&
            mutation.target.closest &&
            mutation.target.closest('.product__media,.product__media-item')
          ) {
            touched = true;
          }
        });
        if (touched) restoreBase();
      }).observe(document.documentElement, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class'],
      });
    } catch (error) {}

    document.addEventListener(
      'mouseover',
      function (event) {
        if (event.target && event.target.closest && event.target.closest('.product__media,.product__media-item')) {
          stripOverlays();
          restoreBase();
        }
      },
      true,
    );
  }

  function installCatalogRoomCycle() {
    if (window.__clawdbotCatalogRoomCycle20260606All) return;
    window.__clawdbotCatalogRoomCycle20260606All = true;

    var CATALOG_ROOM_CYCLE_MARKER = 'clawdbot-catalog-room-cycle-20260606-all';
    var activeCard = null;
    var roomUrlPromiseByHandle = {};

    function cleanUrl(url) {
      return String(url || '').split('?')[0];
    }

    function isRoomCatalogUrl(url) {
      var clean = cleanUrl(url).toLowerCase();
      return clean && !/(^|[_/-])(flat|zoom|hover)([_/. -]|$)/.test(clean);
    }

    function sizedUrl(url) {
      if (!url) return url;
      if (/[?&]width=/.test(url)) return url;
      return url.indexOf('?') === -1 ? url + '?width=900' : url + '&width=900';
    }

    function uniqueUrls(urls) {
      var seen = {};
      return urls.filter(function (url) {
        var key = cleanUrl(url);
        if (!key || seen[key]) return false;
        seen[key] = true;
        return true;
      });
    }

    function cardFromEvent(event) {
      var pointed = null;
      if (event && typeof event.clientX === 'number' && typeof event.clientY === 'number') {
        pointed = document.elementFromPoint(event.clientX, event.clientY);
      }
      var node = pointed || (event && event.target);
      return node && node.closest && node.closest('#product-grid .card-wrapper, .featured-products .product-card');
    }

    function productHandle(card) {
      var link =
        card && card.matches && card.matches('a[href*="/products/"]')
          ? card
          : card && card.querySelector && card.querySelector('a[href*="/products/"]');
      if (!link) return null;
      try {
        var url = new URL(link.getAttribute('href'), window.location.origin);
        var parts = url.pathname.split('/').filter(Boolean);
        var index = parts.indexOf('products');
        return index !== -1 ? parts[index + 1] : null;
      } catch (error) {
        var match = String(link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
        return match && match[1];
      }
    }

    function absoluteUrl(url) {
      url = String(url || '');
      if (url.indexOf('//') === 0) return window.location.protocol + url;
      if (url.charAt(0) === '/') return window.location.origin + url;
      return url;
    }

    function embeddedRoomUrls(card) {
      var node = card && card.querySelector && card.querySelector('script.clawdbot-card-room-urls');
      if (!node) return [];
      try {
        return uniqueUrls(
          JSON.parse(node.textContent || '[]')
            .map(absoluteUrl)
            .filter(isRoomCatalogUrl)
            .map(sizedUrl),
        );
      } catch (error) {
        return [];
      }
    }

    function currentCardImageUrl(card) {
      var image =
        card &&
        card.querySelector &&
        (card.querySelector('.media.media--hover-effect>img.motion-reduce, .card__media img.motion-reduce, .product-img-wrap img') ||
          card.querySelector('img'));
      return image ? sizedUrl(absoluteUrl(image.currentSrc || image.src)) : null;
    }

    function loadRoomUrls(handle, card) {
      var embedded = embeddedRoomUrls(card);
      if (embedded.length) return Promise.resolve(embedded);
      if (!handle) return Promise.resolve([]);
      if (roomUrlPromiseByHandle[handle]) return roomUrlPromiseByHandle[handle];
      roomUrlPromiseByHandle[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('product fetch failed');
          return response.json();
        })
        .then(function (product) {
          return uniqueUrls((product.images || []).filter(isRoomCatalogUrl).map(sizedUrl));
        })
        .catch(function () {
          return [];
        });
      return roomUrlPromiseByHandle[handle];
    }

    function keepBaseImageVisible(card) {
      card
        .querySelectorAll('.media.media--hover-effect>img.motion-reduce, .card__media img.motion-reduce, .product-img-wrap img')
        .forEach(function (image) {
          image.style.setProperty('display', 'block', 'important');
          image.style.setProperty('width', '100%', 'important');
          image.style.setProperty('height', '100%', 'important');
          image.style.setProperty('object-fit', 'cover', 'important');
          image.style.setProperty('opacity', '1', 'important');
          image.style.setProperty('visibility', 'visible', 'important');
        });
    }

    function stopFlatCycles(card) {
      card.__clawdbotSectionCycleActive = false;
      card.__clawdbotFlatCycleActive = false;
      card.__clawdbotSectionCycleToken = (card.__clawdbotSectionCycleToken || 0) + 1;
      card.__clawdbotFlatCycleToken = (card.__clawdbotFlatCycleToken || 0) + 1;
      window.clearInterval(card.__clawdbotSectionCycleTimer);
      window.clearInterval(card.__clawdbotFlatCycleTimer);
      card
        .querySelectorAll('.clawdbot-flat-cycle-overlay, .clawdbot-section-flat-cycle-overlay, .clawdbot-zoom-overlay')
        .forEach(function (overlay) {
          overlay.style.setProperty('opacity', '0', 'important');
          overlay.style.setProperty('visibility', 'hidden', 'important');
          overlay.style.setProperty('display', 'none', 'important');
        });
    }

    function ensureOverlay(card) {
      var overlay = card.querySelector('.clawdbot-room-cycle-overlay');
      if (overlay) return overlay;
      var image = card.querySelector('img');
      var host =
        (image && (image.closest('.media') || image.closest('.product-img-wrap') || image.closest('.card__media'))) ||
        card.querySelector('.media, .product-img-wrap, .card__media, .card__inner') ||
        card;
      overlay = document.createElement('div');
      overlay.className = 'clawdbot-room-cycle-overlay';
      overlay.setAttribute('aria-hidden', 'true');
      overlay.style.cssText =
        'position:absolute;inset:0;background-color:#101010;background-size:cover;background-position:center center;background-repeat:no-repeat;display:block!important;opacity:0!important;visibility:hidden!important;transition:opacity 260ms ease-in-out;pointer-events:none!important;z-index:1100;';
      host.style.position = 'relative';
      host.style.overflow = 'hidden';
      host.appendChild(overlay);
      return overlay;
    }

    function applyUrl(card, overlay, url) {
      if (!url || !card.__clawdbotRoomCycleActive) return;
      stopFlatCycles(card);
      overlay.style.backgroundImage = 'url("' + String(url).replace(/"/g, '\\"') + '")';
      overlay.style.setProperty('display', 'block', 'important');
      overlay.style.setProperty('visibility', 'visible', 'important');
      overlay.style.setProperty('opacity', '1', 'important');
    }

    function showUrl(card, overlay, url) {
      var token = card.__clawdbotRoomCycleToken;
      var probe = new Image();
      probe.onload = function () {
        if (!card.__clawdbotRoomCycleActive || card.__clawdbotRoomCycleToken !== token) return;
        applyUrl(card, overlay, url);
      };
      probe.src = url;
    }

    function stopCycle(card) {
      if (!card) return;
      card.__clawdbotRoomCycleActive = false;
      card.__clawdbotRoomCycleToken = (card.__clawdbotRoomCycleToken || 0) + 1;
      window.clearInterval(card.__clawdbotRoomCycleTimer);
      var overlay = card.querySelector('.clawdbot-room-cycle-overlay');
      if (overlay) {
        overlay.style.setProperty('opacity', '0', 'important');
        window.setTimeout(function () {
          if (!card.__clawdbotRoomCycleActive) overlay.style.setProperty('visibility', 'hidden', 'important');
        }, 260);
      }
      if (activeCard === card) activeCard = null;
    }

    function startCycle(card, handle) {
      if (!card || card.__clawdbotRoomCycleActive) return;
      if (!handle) return;
      if (activeCard && activeCard !== card) stopCycle(activeCard);
      activeCard = card;
      card.setAttribute('data-clawdbot-room-cycle', CATALOG_ROOM_CYCLE_MARKER);
      keepBaseImageVisible(card);
      stopFlatCycles(card);
      card.__clawdbotRoomCycleActive = true;
      card.__clawdbotRoomCycleToken = (card.__clawdbotRoomCycleToken || 0) + 1;
      var token = card.__clawdbotRoomCycleToken;
      var overlay = ensureOverlay(card);
      var immediateUrls = embeddedRoomUrls(card);
      var immediateUrl = immediateUrls.length > 1 ? immediateUrls[1] : immediateUrls[0] || currentCardImageUrl(card);
      applyUrl(card, overlay, immediateUrl);
      loadRoomUrls(handle, card).then(function (urls) {
        if (!card.__clawdbotRoomCycleActive || card.__clawdbotRoomCycleToken !== token || !urls.length) {
          if (!immediateUrl) stopCycle(card);
          return;
        }
        var index = urls.length > 1 ? 1 : 0;
        showUrl(card, overlay, urls[index]);
        window.clearInterval(card.__clawdbotRoomCycleTimer);
        card.__clawdbotRoomCycleTimer = window.setInterval(function () {
          stopFlatCycles(card);
          index = (index + 1) % urls.length;
          showUrl(card, overlay, urls[index]);
        }, 900);
      });
      if (!card.__clawdbotRoomCycleLeaveBound) {
        card.__clawdbotRoomCycleLeaveBound = true;
        card.addEventListener('mouseleave', function () {
          stopCycle(card);
        });
        card.addEventListener('pointerleave', function () {
          stopCycle(card);
        });
      }
    }

    function handleRoomCardHover(event) {
      var card = cardFromEvent(event);
      var handle = card && productHandle(card);
      if (!card || !handle) return;
      startCycle(card, handle);
      event.stopImmediatePropagation();
    }

    ['pointerover', 'pointermove', 'mouseover', 'mousemove'].forEach(function (eventName) {
      window.addEventListener(eventName, handleRoomCardHover, true);
    });
  }

  installProductRoomOnlyGuard();
  installCatalogRoomCycle();
})();
